export abstract class QaroniCache<T = unknown> {
  protected element: T;

  protected flying: boolean;

  abstract canReturn(...attributes: unknown[]): boolean;

  abstract canApi(...attributes: unknown[]): boolean;

  public startToFly(): void {
    this.flying = true;
  }

  public endFlying(): void {
    this.flying = false;
  }

  public get(): T {
    return { ...this.element };
  }

  public set(element: T): void {
    delete this.element;
    this.element = { ...element };
  }

  public empty(): void {
    delete this.element;
  }
}
